import { Component, HostListener } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RegisterFields, generateRegisterForm } from '../../../../routes/auth/register/form.functions';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerComponent } from '../../../components/banner/banner.component';
import { InlineInputControlComponent } from '../../../components/form/inline-input-control/inline-input-control.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { AuthSuccessDialogBody, AuthSuccessDialogComponent, AuthSuccessDialogType } from '../auth-success-dialog/auth-success-dialog.component';
import { AuthErrorDialogComponent } from '../auth-error-dialog/auth-error-dialog.component';
import { DataService } from '../../../../core/providers/data/data.service';
import {
  RegisterMutation,
  RegisterMutationVariables,
} from '../../../../graphql/generated/generated-types';
import { REGISTER } from './register.graphql';
import { take } from 'rxjs';
import { NotAvailableOverlayComponent } from '../../../components/not-available-overlay/not-available-overlay.component';
import { Router } from '@angular/router';
import { VehicleTypeService } from '../../../services/vehicle-type.service';
import { VehicleType } from '../../add-vehicle-form/vehcle-type.interfaces';
@Component({
  selector: 'app-register-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    RippleModule,
    DividerModule,
    BannerComponent,
    InlineInputControlComponent,
    LoginDialogComponent,
    AuthErrorDialogComponent,
    AuthSuccessDialogComponent,
    NotAvailableOverlayComponent,
  ],
  templateUrl: './register-dialog.component.html',
  styleUrl: './../auth-dialog-pages.scss',
})
export class RegisterDialogComponent {
  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (this.registerForm.valid) {
      this.register();
    }
  }

  public registerForm: UntypedFormGroup = generateRegisterForm();
  public RegisterFields = RegisterFields;

  public submited = false;
  public loading = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private dataService: DataService,
    private router: Router,
    private vehicleTypeService: VehicleTypeService
  ) { }

  register() {
    this.dataService
      .mutate<RegisterMutation, RegisterMutationVariables>(REGISTER, {
        input: {
          firstName: this.registerForm.get(RegisterFields.FirstName)?.value,
          lastName: this.registerForm.get(RegisterFields.LastName)?.value,
          emailAddress: this.registerForm.get(RegisterFields.Email)?.value,
        },
      })
      .pipe(take(1))
      .subscribe({
        next: ({ registerCustomerAccount }) => {
          switch (registerCustomerAccount.__typename) {
            case 'Success':
              break;
          }
        },
        error: () => {
          this.openAuthErrorDialog();
        },
        complete: () => {
          this.openAuthSuccessDialog();
        },
      });
  }

  public openLoginDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(
      LoginDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      }
    );

    dialogRef.onClose.subscribe((result) => {
              if(result){
                       /*
        this.router.navigate(['/'], { queryParamsHandling: 'merge', skipLocationChange: true }).then(() => {
          this.router.navigate(['/' + (this.vehicleTypeService.currentVehicleType)], {
            queryParamsHandling: 'merge'
          });
        })
           */
                }
    });
  }

  public openAuthErrorDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(
      AuthErrorDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      }
    );

    dialogRef.onClose.subscribe((result) => { });
  }

  public openAuthSuccessDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(
      AuthSuccessDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
        data: {
          email: this.registerForm.get(RegisterFields.Email)?.value,
          type: 'Register' as AuthSuccessDialogType,
        } as AuthSuccessDialogBody
      }
    );

    dialogRef.onClose.subscribe((result) => { });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
